export const styles = {
  versionDetailsContainer: {
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "calc(70%)",
    alignContent: "left",
    justifyItems: "left",
    textOverflow: "ellipsis",
  } as const,
};
